import brazilPhoneCodes from '~constants/brazilPhoneCodes'
import { StringSchema } from 'yup'

export default function cellphone(this: StringSchema, message: string) {
  return this.test('cellphone', message, (maskedCellphone = '') => {
    const cellphoneWithoutMask = maskedCellphone.replace(/\D/g, '')
    const phoneCode = cellphoneWithoutMask.slice(0, 2)
    const hasElevenDigits = cellphoneWithoutMask.length === 11
    const isThirdNumberEqualNine = cellphoneWithoutMask.charAt(2) === '9'
    const isValidBrazilianDDD = brazilPhoneCodes.includes(phoneCode)

    return isThirdNumberEqualNine && isValidBrazilianDDD && hasElevenDigits
  })
}
